import SignalIcon from '@ubnt/icons/SignalIcon';
import AppHeader from '@ubnt/ui-components/AppHeader/AppHeader';
import { useApplicationStore } from 'modules/application/store';
import { isFromApp } from 'utils/isFromApp';

import classes from './Layout.module.scss';

export function Header() {
  const isMobile = useApplicationStore((state) => state.isMobile);

  if (isMobile || isFromApp) {
    return null;
  }

  return (
    <AppHeader
      className={classes.header}
      size="classic"
      title={import.meta.env.VITE_TITLE}
      titleClassName={classes.headerTitle}
      icon={<SignalIcon variant="fill" size="logo" color="#50565E" />}
    />
  );
}
